import Vue from 'vue'
import Vuex from 'vuex'

import loader from '@/store/modules/loader'
import tags from '@/store/modules/tags'
import menu from '@/store/modules/menu'
import authentication from '@/store/modules/authentication'
import permissions from '@/store/modules/permissions'
import roles from '@/store/modules/roles'
import users from '@/store/modules/users'
import companies from '@/store/modules/companies'
import projects from '@/store/modules/projects'
import objects from '@/store/modules/objects'
import images from '@/store/modules/images'
import schedules from '@/store/modules/schedule'
import address from '@/store/modules/address'
import inspections from '@/store/modules/inspections'
import locations from '@/store/modules/locations'
import damages from '@/store/modules/damages'
import insight from '@/store/modules/insight'
import notifications from '@/store/modules/notifications'
import widgets from '@/store/modules/widgets'
import onlineDossier from '@/store/modules/onlineDossier'
import onlineProjectDossier from '@/store/modules/onlineProjectDossier'
import revisions from '@/store/modules/revisions'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		loader,
		address,
		tags,
		menu,
		authentication,
		permissions,
		roles,
		companies,
		projects,
		objects,
		images,
		schedules,
		inspections,
		locations,
		damages,
		revisions,
		users,
		insight,
		notifications,
		widgets,
		onlineDossier,
		onlineProjectDossier
	},
})